import React from "react";

export const VisualiseSvg = () => {
  return (
    <svg width={169.666} height={175.863} viewBox="0 0 174.5 189.096">
      <g data-name="Group 63">
        <path
          fill="#eaeaea"
          d="M96.749 189.098l12.7-8.885 13.626-9.43 18.151-12.645a33.336 33.336 0 003.979-14.063 236.686 236.686 0 00-.382-29.924l-.368-7.454-1.186-10.833-1.8-12.755-2.7-15.7-2.984-14.594-2.821-15.085-2.616-11.651-.409-1.308-14.676-21.544-52.2-3.229v6.541a169.887 169.887 0 01-1.962 24.732s-1.962 11.405-4.415 18.355c0 0-3.352 10.588-7.89 18.355 0 0-5.164 9.866-9.2 15.643l-2.861 4.279-3.025 4.47-2.644 3.706-9.43 13.109-8.639 12.237-13 18.069 2.18 5.887 19.3 3.652 15.643 3s17.715 3.216 26.6 8.067c0 0 7.467 2.834 18.042 12.482a124.532 124.532 0 0114.987 16.516z"
          data-name="Path 45"
        />
        <g fill="#dedede" data-name="Group 46">
          <path
            d="M3.742 133.989l3.944 11.835-5.562-.91L0 139.048z"
            data-name="Path 46"
          />
          <path
            d="M21.743 148.35l12.945 2.53s-3.641-26.5-14.867-39.443l-8.091 11.428s10.013 15.979 10.013 25.485z"
            data-name="Path 47"
          />
          <path
            d="M30.036 97.075l7.889-11.529s33.374 40.252 25.688 75.042l-12.035-5.36s-3.843-42.881-21.542-58.153z"
            data-name="Path 48"
          />
        </g>
        <path
          fill="#dedede"
          d="M83.037 172.953l9.124 10.687s36.184-40.515 0-96.184c0 0-3.3-9.89-15.26-7.337 0 0-13.058-26.8-22.34-25.681L50 65.921s41.533 71.939 33.037 107.032z"
          data-name="Path 49"
        />
        <path
          fill="#dedede"
          d="M128.511 55.273l13.8 82.091s-22.053-86.161-41.05-100.748c0 0-5.014-14.681-13.908-20.24a.716.716 0 00-.565 0S72.088 1.111 67 .546l23.18 1.131s.226 23.067 14.473 21.484"
          data-name="Path 51"
        />
        <g
          fill="#ed1b2e"
          stroke="#ed1b2e"
          strokeMiterlimit={10}
          strokeWidth={2}
          data-name="Group 26"
          transform="translate(46.478 48.698)"
        >
          <path
            d="M81.214 60.308l35.56-44.407 2.297 1.84-35.559 44.407z"
            data-name="Rectangle 7"
          />
          <path
            strokeWidth={2.001}
            d="M36.052 8.609l2.351-2.315 50.025 50.808-2.351 2.315z"
            data-name="Rectangle 8"
          />
          <path
            d="M7.95 70.332L37.283 6.295l3.106 1.422-29.333 64.038z"
            data-name="Rectangle 9"
          />
          <circle
            cx={7.95}
            cy={7.95}
            r={7.95}
            data-name="Ellipse 4"
            transform="translate(0 63.804)"
          />
          <circle
            cx={7.95}
            cy={7.95}
            r={7.95}
            data-name="Ellipse 5"
            transform="translate(77.169 49.888)"
          />
          <circle
            cx={7.95}
            cy={7.95}
            r={7.95}
            data-name="Ellipse 5"
            transform="translate(30.222)"
          />
          <circle
            cx={7.95}
            cy={7.95}
            r={7.95}
            data-name="Ellipse 6"
            transform="translate(111.121 5.45)"
          />
        </g>
      </g>
    </svg>
  );
};
